<template>
  <TheNavbar />

  <div class="row text-center mt-5 mb-3">
    <div class="col">
      <h2 class="">Create New Bot</h2>
      <p class="mb-2">You can create {{ userMaxBotsMix - userBots?.length }} more Bots.</p>
    </div>
  </div>

  <form @submit.prevent="">

    <div v-if="step == 1 && platformExchanges">

      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

          <div class="card mb-3">
            <div class="card-header">
              <div class="row flex-between-end">
                <div class="col-auto text-center">
                  <h5 class="mb-0" data-anchor="data-anchor">Select Account Type</h5>
                </div>
              </div>
            </div>
            <div class="card-body bg-body-tertiary text-start">
              <div class="row row-cols-5 row-cols-sm-5 row-cols-md-5 row-cols-lg-5 row-cols-xl-5 row-cols-xxl-5 g-2 g-xl-3 g-xxl-3 justify-content-center">
                <div class="col">
                  <img @click="selectExchangeTradingAccount('spot')" :class="'tradingAccount img-fluid rounded mx-auto d-block p-0 p-sm-1 p-md-1 p-xl-0 '+getSelectedExchangeTradingAccountClasses('spot')" :src="'/exchanges/trading_account_spot.png'" title="Spot" />
                </div>
                <div class="col">
                  <img @click="selectExchangeTradingAccount('perpetual')" :class="'tradingAccount img-fluid rounded mx-auto d-block p-0 p-sm-1 p-md-1 p-xl-0 '+getSelectedExchangeTradingAccountClasses('perpetual')" :src="'/exchanges/trading_account_futures.png'" title="Futures" />
                </div>
              </div>
              <div class="text-center fs-10 mt-3">
                <div v-if="form.tradingAccount == 'spot'">
                  <b>SPOT</b> Bots support LONG operations (long, flat).
                </div>
                <div v-if="form.tradingAccount == 'perpetual'">
                  <b>FUTURES</b> Bots support LONG & SHORT operations (long, flat, short) with leverage.
                </div>
              </div>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header">
              <div class="row flex-between-end">
                <div class="col-auto text-center">
                  <h5 class="mb-0" data-anchor="data-anchor">Select Exchange</h5>
                </div>
              </div>
            </div>
            <div class="card-body bg-body-tertiary text-start">

              <!-- <div class="row row-cols-5 row-cols-sm-5 row-cols-md-5 row-cols-lg-5 row-cols-xl-5 row-cols-xxl-5 g-2 g-xl-3 g-xxl-3 justify-content-center align-items-center"> -->
              <div class="row row-cols-5 row-cols-sm-5 row-cols-md-5 row-cols-lg-5 row-cols-xl-5 row-cols-xxl-5 g-3 g-xl-3 g-xxl-3 justify-content-center">
                <div v-for="exchange in platformExchangesFiltered" :key="exchange.id" class="col">
                  <!-- TODO: Hide this -->
                  <!-- <img v-if="exchange" @click="selectExchange(exchange)" :class="'exchange img-fluid rounded mx-auto d-block p-0 p-sm-1 p-md-1 p-xl-0 '+getSelectedExchangeClasses(exchange.id)" :src="'/exchanges/'+exchange.id+'.png'" :title="exchange.name" /> -->

                  <!-- TODO: Show this -->
                  <img v-if="exchangeEnabled(exchange)" @click="selectExchange(exchange)" :class="'exchange img-fluid rounded mx-auto d-block p-0 p-sm-1 p-md-1 p-xl-0 '+getSelectedExchangeClasses(exchange.id)" :src="'/exchanges/'+exchange.id+'.png'" :title="exchange.name" />
                  <img v-else :class="'exchange img-fluid rounded mx-auto d-block p-0 p-sm-1 p-md-1 p-xl-0 '+getSelectedExchangeClasses(exchange.id)" :src="'/exchanges/'+exchange.id+'_comingsoon.png'" :title="exchange.name" />
                </div>
              </div>

            </div>
          </div>

        </div> <!-- col -->
      </div> <!-- row -->

      <div v-if="selectedExchange" class="row justify-content-center">
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

          <div class="card mb-3">
            <div class="card-header">
              <div class="row flex-between-end">
                <div class="col-auto text-center">
                  <h5 class="mb-0" data-anchor="data-anchor">Validate {{ selectedExchange.name }} API Credentials</h5>
                </div>
              </div>
            </div>
            <div class="card-body bg-body-tertiary text-start">

              <div class="row mb-1 justify-content-center">
                <div class="col-6">
                  <div class="form-floating">
                    <input v-model="form.exchangeConfig.apiKey" class="form-control" type="text" :placeholder="apiKeyLabelName">
                    <label>{{ apiKeyLabelName }}</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-floating">
                    <input v-model="form.exchangeConfig.apiSecret" class="form-control" type="text" :placeholder="apiSecretLabelName">
                    <label>{{ apiSecretLabelName }}</label>
                  </div>
                </div>
              </div>
              <div v-if="['kucoin', 'bitget', 'okx', 'okxus', 'okxeea'].includes(selectedExchange.id)" class="row mb-1 mt-2 justify-content-center">
                <div class="col-12">
                  <div class="form-floating">
                    <input v-model="form.exchangeConfig.passphrase" class="form-control" type="text" placeholder="API Key">
                    <label>API Passphrase</label>
                  </div>
                </div>
              </div>
              <div v-if="selectedExchange.id == 'hyperliquid'" class="row mb-1 mt-2 justify-content-center">
                <div class="col-12">
                  <div class="form-floating">
                    <input v-model="form.exchangeConfig.passphrase" class="form-control" type="text" placeholder="Public Address">
                    <label>Master, Vault or Sub-Account Address</label>
                  </div>
                </div>
              </div>
              <div v-if="formValidations.apiKey" class="row mb-3 text-center justify-content-center">
                <div class="col-auto">
                  <div class="invalid-feedback d-block fs-10">{{ formValidations.apiKey }}</div>
                </div>
              </div>

              <div v-if="!loading" class="row mt-3">
                <div class="col-4 d-flex justify-content-start mb-2">
                  <button @click="cancel" type="submit" class="btn btn-secondary">Cancel</button>&nbsp;
                </div>
                <div class="col-8 d-flex justify-content-end mb-2">
                  <button @click="validateExchange" type="submit" class="btn btn-primary">Validate</button>
                </div>
              </div>
              <div v-if="loading" class="row text-center mt-3">
                <div class="col-12">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div> <!-- col -->
      </div> <!-- row -->

      <div v-if="selectedExchange" class="row mb-1 justify-content-center text-left">
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
          <div class="alert alert-primary" role="alert">
            With your API keys, SIGNUM can only perform trade operations, nothing else.<br>
            Only give the permissions needed for trading, as shown below.
          </div>
        </div>
      </div> <!-- row -->

    </div> <!-- step 1 -->

    <div v-if="step == 2">
      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

          <div class="card mb-3">
            <div class="card-header">
              <div class="row flex-between-end">
                <div class="col-auto text-center">
                  <h5 class="mb-0" data-anchor="data-anchor">Create your Bot</h5>
                </div>
              </div>
            </div>
            <div class="card-body bg-body-tertiary text-start">
              <BotEditForm @save="onSave" :loading="loading" :exchangeId="form.exchangeId" :exchangeTradingAccount="form.tradingAccount" :apiKey="form.exchangeConfig.apiKey" :apiSecret="form.exchangeConfig.apiSecret" :apiPassphrase="form.exchangeConfig.passphrase" />
            </div>
          </div>

        </div> <!-- col -->
      </div> <!-- row -->
    </div> <!-- step 2 -->

    <div v-if="step == 3">
      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

          <div class="card mb-3">
            <div class="card-header">
              <div class="row flex-between-end">
                <div class="col-auto text-center">
                  <h5 class="mb-0" data-anchor="data-anchor">Maximum Bots Reached</h5>
                </div>
              </div>
            </div>
            <div class="card-body bg-body-tertiary text-start">
              <p>You have reached the <span class="fw-bold">maximum amount of Bots</span> you can create with your subscription: <span class="fw-bold">{{ this.userMaxBotsMix }}</span></p>
              <p>Please <a :href="getSupportUrl()" target="_blank"><span class="fw-bold">contact support</span></a> to get more 🤙🏻</p>
            </div>
          </div>

        </div> <!-- col -->
      </div> <!-- row -->
    </div> <!-- step 3 -->

    <!-- Bybit Explainers -->
    <div v-if="selectedExchange?.id == 'bybit'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your $50 Signup Bonus And Win Up To $30,000</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below and get your <span class="fw-bold">SIGNUP BONUS</span>:<br>
                  <a href="https://partner.bybit.com/b/SIGNUM" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the Subaccounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below.
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://www.bybit.com/en/sign-up?affiliate_id=64375&group_id=130061&group_type=1&ref_code=AUTOBOTS" target="_blank"><span class="fw-bold">Bybit account</span></a> and go to your <a href="https://www.bybit.com/app/user/sub-account?affiliate_id=64375&group_id=130061&group_type=1&ref_code=AUTOBOTS" target="_blank"><span class="fw-bold">Subaccounts</span></a>.<br>
                      Click on <span class="fw-bold">Create Subaccount</span>.<br>
                      Choose <span class="fw-bold">Standard Subaccount</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_subaccount_step1.jpg" />

                    <p>
                      Give it a name and choose the settings as shown.<br>
                      Click <span class="fw-bold">Confirm</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_subaccount_step2_v2.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>

                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Go to your <a href="https://www.bybit.com/app/user/sub-account?affiliate_id=64375&group_id=130061&group_type=1&ref_code=AUTOBOTS" target="_blank"><span class="fw-bold">Subaccounts</span></a>.<br>
                      For the Subaccount to connect to this Bot, locate the <span class="fw-bold">API</span> column and click on <span class="fw-bold">Management</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_subaccount_step3_v2.jpg" />

                    <p>
                      Now create a new API Key for the Subaccount by clicking on the <span class="fw-bold">Create New Key</span> button.
                      <br>
                      Select the <span class="fw-bold">System-genearted API Keys</span> option.</p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_apikey_create.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bybit_apikey_create.jpg" zoom="/exchanges/explainers/bybit_apikey_create.jpg" />

                    <p>
                      Choose the <span class="fw-bold">settings</span> as shown below.<br>
                      By choosing SIGNUM from the dropdown, {{ selectedExchange.name }} already automatically restricts usage to our IP address (18.199.127.118) only, for extra security.
                    </p>
                    <vue-image-zoomer v-if="form.tradingAccount == 'spot'" img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bybit_apikey_settings_v2.jpg" zoom="/exchanges/explainers/bybit_apikey_settings_v2.jpg" />
                    <vue-image-zoomer v-if="form.tradingAccount == 'perpetual'" img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bybit_perps_apikey_settings.jpg" zoom="/exchanges/explainers/bybit_perps_apikey_settings.jpg" />

                    <p>
                      Now paste the <span class="fw-bold">API Key & API Secret</span> into SIGNUM.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_paste_into_signum.jpg" />

                    <p>
                      Ensure the new API Key you have created is <span class="fw-bold">Permanent</span> otherwise it will expire in a few months! Scroll to the right to find that column.
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_apikey_permanent.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bybit_apikey_permanent.jpg" zoom="/exchanges/explainers/bybit_apikey_permanent.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Bybit Explainers -->
    <div v-if="selectedExchange?.id == 'bybiteea'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the Subaccounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below.
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://www.bybit.eu/en/sign-up?affiliate_id=64375&group_id=130061&group_type=1&ref_code=AUTOBOTS" target="_blank"><span class="fw-bold">Bybit account</span></a> and go to your <a href="https://www.bybit.eu/app/user/sub-account?affiliate_id=64375&group_id=130061&group_type=1&ref_code=AUTOBOTS" target="_blank"><span class="fw-bold">Subaccounts</span></a>.<br>
                      Click on <span class="fw-bold">Create Subaccount</span>.<br>
                      Choose <span class="fw-bold">Standard Subaccount</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybiteea_subaccount_step1.jpg" />

                    <p>
                      Give it a name and choose the settings as shown.<br>
                      Click <span class="fw-bold">Confirm</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_subaccount_step2_v2.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>

                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Go to your <a href="https://www.bybit.eu/app/user/sub-account?affiliate_id=64375&group_id=130061&group_type=1&ref_code=AUTOBOTS" target="_blank"><span class="fw-bold">Subaccounts</span></a>.<br>
                      For the Subaccount to connect to this Bot, locate the <span class="fw-bold">API</span> column and click on <span class="fw-bold">Management</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_subaccount_step3_v2.jpg" />

                    <p>
                      Now create a new API Key for the Subaccount by clicking on the <span class="fw-bold">Create New Key</span> button.
                      <br>
                      Select the <span class="fw-bold">System-genearted API Keys</span> option.</p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_apikey_create.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bybit_apikey_create.jpg" zoom="/exchanges/explainers/bybit_apikey_create.jpg" />

                    <p>
                      Choose the <span class="fw-bold">settings</span> as shown below.<br>
                      By choosing SIGNUM from the dropdown, {{ selectedExchange.name }} already automatically restricts usage to our IP address (18.199.127.118) only, for extra security.
                    </p>
                    <vue-image-zoomer v-if="form.tradingAccount == 'spot'" img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bybiteea_apikey_settings_v2.jpg" zoom="/exchanges/explainers/bybiteea_apikey_settings_v2.jpg" />

                    <p>
                      Now paste the <span class="fw-bold">API Key & API Secret</span> into SIGNUM.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_paste_into_signum.jpg" />

                    <p>
                      Ensure the new API Key you have created is <span class="fw-bold">Permanent</span> otherwise it will expire in a few months! Scroll to the right to find that column.
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bybit_apikey_permanent.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bybit_apikey_permanent.jpg" zoom="/exchanges/explainers/bybit_apikey_permanent.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Kraken Explainers -->
    <div v-if="selectedExchange?.id == 'kraken'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel" aria-labelledby="text-tab">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊<br>
                      <br>
                      <span class="fw-bold">Kraken does NOT support Subaccounts</span>.<br>
                      They recommend creating new accounts with different email addresses. <span class="fw-bold">If you're using Gmail</span>, you can use this trick to create infinite aliases without any setup: <a href="https://www.youtube.com/shorts/jTxRCEpUgt0" target="_blank"><span class="fw-bold">YouTube Video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a>
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the accounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below :)
                    </p>
                    <hr>
                    <p>
                      Login to your <a href="https://pro.kraken.com" target="_blank"><span class="fw-bold">Kraken PRO</span></a> account.
                    </p>
                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Click on <span class="fw-bold">Settings</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kraken_settings.jpg" />

                    <p>Click on the <span class="fw-bold">API</span> tab and then click on <span class="fw-bold">Create API key</span>.</p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kraken_apikey_create.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/kraken_apikey_create.jpg" zoom="/exchanges/explainers/kraken_apikey_create.jpg" />

                    <p>
                      Give it a <span class="fw-bold">name</span> and select the <span class="fw-bold">permissions</span> as shown.<br>
                      Enable <span class="fw-bold">IP address restrictions</span> and add SIGNUM's IP address, for additional security: <span class="fw-bold">18.199.127.118</span><br>
                      Click <span class="fw-bold">Generate key</span>.
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kraken_apikey_settings.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/kraken_apikey_settings.jpg" zoom="/exchanges/explainers/kraken_apikey_settings.jpg" />

                    <p>
                      Now paste the <span class="fw-bold">API Key & API Secret</span> into SIGNUM.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kraken_paste_into_signum.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your account...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Binance Explainers -->
    <div v-if="selectedExchange?.id == 'binance'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your 15% Trading Fee Discount on {{ selectedExchange.name }} (Spot)</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below to get your <span class="fw-bold">FEE DISCOUNT</span>:<br>
                  <a href="https://accounts.binance.com/register?ref=SIGNUM" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the accounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below :)
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://accounts.binance.com/register/?ref=T7HMHDW5" target="_blank"><span class="fw-bold">Binance</span></a> account and go to your <a href="https://www.binance.com/en/my/sub-account/account-management/?ref=T7HMHDW5" target="_blank"><span class="fw-bold">Sub Accounts</span></a>.<br>
                      Click on <span class="fw-bold">Create Sub Account</span>
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_create_subaccount_button.jpg" />

                    <p>
                      Select the <span class="fw-bold">settings</span> as shown and give it a good name.<br>
                      Click <span class="fw-bold">Create Sub Account</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_create_subaccount_settings.jpg" />

                    <p>
                      Binance will now create a virtual email for your Sub Account.<br>
                      In this example it's: <span class="fw-bold">strategybtc_virtual@hof0hvm4noemail.com</span><br>
                      This is how you identify the Sub Account from now on.
                    </p>

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>To create your API Keys, go to <a href="https://www.binance.com/en/my/sub-account/api-management/?ref=T7HMHDW5" target="_blank"><span class="fw-bold">API Management</span></a> (left side menu).</p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_api_management_menu.jpg" />

                    <p>Click on <span class="fw-bold">Create API</span>.</p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_create_api_button.jpg" />

                    <p>
                      Choose the <span class="fw-bold">System generated</span> API Key type.<br>
                      Click <span class="fw-bold">Next</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_api_type.jpg" />

                    <p>Choose the <span class="fw-bold">Sub Account</span> for which you want to generate the API Keys for.</p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_api_choose_subaccount.jpg" />

                    <p>
                      Type <span class="fw-bold">SIGNUM</span> in the <span class="fw-bold">API Key Label</span> field.<br>
                      Click <span class="fw-bold">Next</span>.<br>
                      Do the <span class="fw-bold">2FA</span> as needed.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_api_key_label.jpg" />

                    <p>
                      Now add SIGNUM's <span class="fw-bold">IP Address (18.199.127.118)</span>, otherwise Binance won't allow you to enable "Spot & Margin Trading".<br>
                      Click <span class="fw-bold">Confirm</span>.
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_add_ip_address.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/binance_add_ip_address.jpg" zoom="/exchanges/explainers/binance_add_ip_address.jpg" />

                    <p>
                      Now enable <span class="fw-bold">Spot & Margin Trading</span>.<br>
                      Click <span class="fw-bold">Save</span> and do the 2FA process as needed.
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_enable_spot_trading.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/binance_enable_spot_trading.jpg" zoom="/exchanges/explainers/binance_enable_spot_trading.jpg" />

                    <p>
                      Copy the <span class="fw-bold">API Key & Secret Key</span> into SIGNUM and click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_copy_keys.jpg" />
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/binance_paste_into_signum.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- KuCoin Explainers -->
    <div v-if="selectedExchange?.id == 'kucoin'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your 20% Trading Fee Discount on {{ selectedExchange.name }} (Spot, Futures)</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below to get your <span class="fw-bold">FEE DISCOUNT</span>:
                  <br>
                  <a href="https://www.kucoin.com/r/af/SIGNUMONEY" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the accounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below :)
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://kcst.art/z5coVMyRmp8d" target="_blank"><span class="fw-bold">KuCoin account</span></a> and go to your <a href="https://kcst.art/CJT1RCjcIyvY" target="_blank"><span class="fw-bold">Sub-Accounts</span></a>.<br>
                      Click on <span class="fw-bold">Create Sub-Account</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kucoin_create_subaccount_button.jpg" />

                    <p>
                      Select the <span class="fw-bold">settings</span> as shown and give it a good name.<br>
                      Choose any <span class="fw-bold">Login Password</span>, you won't need it later anyhow.<br>
                      Click <span class="fw-bold">Save</span>.<br>
                      Do the <span class="fw-bold">2FA</span> as needed.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kucoin_create_subaccount_form.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Now let's create the API Keys.<br>
                      For that click on <span class="fw-bold">Settings</span> (or the three dots) and then on <span class="fw-bold">View API</span> for the Sub-Account in question.
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kucoin_view_api_v2.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/kucoin_view_api_v2.jpg" zoom="/exchanges/explainers/kucoin_view_api_v2.jpg" />

                    <p>Click on <span class="fw-bold">Create API</span>.</p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kucoin_create_api_button_v2.jpg" />

                    <p>
                      Choose the <span class="fw-bold">settings</span> as shown.<br>
                      Choose an <span class="fw-bold">API Passphrase</span> and <span class="fw-bold">remember</span> it. You will need it for the SIGNUM setup.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kucoin_create_api_form_1.jpg" />

                    <p>
                      Allow SIGNUM's IP address, for additional security: <span class="fw-bold">18.199.127.118</span><br>
                      Copy/Paste the IP and then click <span class="fw-bold">Add</span>.<br>
                      Make sure the IP appears like the arrow shows and click <span class="fw-bold">Next</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kucoin_create_api_form_2.jpg" />

                    <p>
                      Now paste your new <span class="fw-bold">API Key, API Secret & Passphrase</span> (the one you defined above) into SIGNUM.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/kucoin_paste_into_signum.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Coinbase Explainers -->
    <div v-if="selectedExchange?.id == 'coinbase'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Portfolio</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Portfolio</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Portfolio (aka. Subaccount).</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the Portfolios you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below.
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://www.coinbase.com/" target="_blank"><span class="fw-bold">Coinbase account</span></a> and go to your <a href="https://www.coinbase.com/advanced-portfolio" target="_blank"><span class="fw-bold">Portfolios</span></a>.<br>
                      If you don't see that feature, turn ON <span class="fw-bold">Advanced Mode</span> in the bottom left corner.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/coinbase_turn_on_advanced_mode.jpg" />

                    <p>
                      Click on <span class="fw-bold">New portfolio</span>.<br>
                      Give it a <span class="fw-bold">name</span>.<br>
                      Click <span class="fw-bold">Create</span>.<br>
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/coinbase_create_portfolio.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/coinbase_create_portfolio.jpg" zoom="/exchanges/explainers/coinbase_create_portfolio.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>

                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Go to the <a href="https://www.coinbase.com/settings/api" target="_blank"><span class="fw-bold">API</span></a> page.<br>
                      Click on <span class="fw-bold">Create API key</span>
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/coinbase_go_to_api_page.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/coinbase_go_to_api_page.jpg" zoom="/exchanges/explainers/coinbase_go_to_api_page.jpg" />

                    <p>
                      Fill in the form as shown below.<br>
                      For the <span class="fw-bold">Portfolio</span> choose the one you have just created before.<br>
                      Paste our IP address into the <span class="fw-bold">IP whitelist</span> field (extra security): <span class="fw-bold">18.199.127.118</span><br>
                      Click <span class="fw-bold">Create & download</span>. Do the 2FA as needed.<br>
                      <i>You can delete the .json file that Coinabse gave you.</i>
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/coinbase_create_api_key.jpg" />

                    <p>
                      If you are having issues creating the <span class="fw-bold">API Keys</span>, the most common cause is the <span class="fw-bold">Security Prompt</span>, which is not opening up properly - it has a bug.<br>
                      Go to the <a class="fw-bold" href="https://accounts.coinbase.com/security/settings" target="_blank">Security</a> settings and <span class="fw-bold">turn it OFF</span> and try creating the API key again.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/coinbase_turn_off_security_prompt.jpg" />

                    <p>
                      Now copy the <span class="fw-bold">API key name & Private key</span>, scroll up and paste them into the form.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/coinbase_copy_keys.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Portfolio</span> to put funds on your Portfolio...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- MEXC Explainers -->
    <div v-if="selectedExchange?.id == 'mexc'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your 15% Trading Fee Discount on {{ selectedExchange.name }} (Spot & Futures)</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below to get your <span class="fw-bold">FEE DISCOUNT</span>:<br>
                  <a href="https://www.mexc.com/en-GB/acquisition/custom-sign-up?shareCode=mexc-signum" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the accounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below :)
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://www.mexc.com/en-GB/?shareCode=mexc-signum" target="_blank"><span class="fw-bold">MEXC</span></a> account and go to your <a href="https://www.mexc.com/user/sub-account?shareCode=mexc-signum" target="_blank"><span class="fw-bold">Sub-Account Management</span></a>.<br>
                      Click on <span class="fw-bold">Create a Sub-Account</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_create_subaccount_button.jpg" />

                    <p>
                      Pick this <span class="fw-bold">Subaccount type</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_subaccount_type.jpg" />

                    <p>
                      Give you Subaccount a good and unique <span class="fw-bold">Username</span><br>
                      <span class="fw-bold">ATTENTION:</span> MEXC requires you to have a <span class="fw-bold">NUMBER</span> (e.g. 1, 2, 3) in your username for some reason.<br>
                      Click <span class="fw-bold">Next Step</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_create_subaccount.jpg" />
                    <p>
                      Do 2FA as required.<br>
                      Remember the name you have given this SubAccount as this is how you identify the Subaccount from now on.
                    </p>

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>To create your API Keys, go to <a href="https://www.mexc.com/user/sub-account?tab=openapi&shareCode=mexc-signum" target="_blank"><span class="fw-bold">API</span></a> settings.</p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_api_settings_menu.jpg" />

                    <p>Click on <span class="fw-bold">Create an API</span>.</p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_create_an_api_button.jpg" />

                    <p>
                      Choose the settings as shown below.<br>
                      <span class="fw-bold">Select your Subaccount</span> from the dropdown.<br>
                      To make your API keys permanent, you must paste our IP address: <span class="fw-bold">18.199.127.118</span><br>
                      Do 2FA as required.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_create_api_keys.jpg" />

                    <p>
                      Now copy the <span class="fw-bold">Access Key & Secret Key</span>, scroll up and paste them into the form.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/mexc_copy_keys_to_signum.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Bitget Explainers -->
    <div v-if="selectedExchange?.id == 'bitget'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your 15% Trading Fee Discount on {{ selectedExchange.name }} (Spot & Futures)</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below to get your <span class="fw-bold">FEE DISCOUNT</span>:<br>
                  <a href="https://partner.bitget.com/bg/SIGNUM1" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the accounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below :)
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://www.bitget.com/" target="_blank"><span class="fw-bold">Bitget account</span></a> and go to your <a href="https://www.bitget.com/account/sub-account" target="_blank"><span class="fw-bold">Sub-accounts</span></a>.<br>
                      Click on <span class="fw-bold">Create</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_create_subaccount_button.jpg" />

                    <p>
                      Select the <span class="fw-bold">Sub-account type</span> as shown.<br>
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_choose_subaccount_type.jpg" />

                    <p>
                      Enter a <span class="fw-bold">Sub-account name</span>.<br>
                      Click <span class="fw-bold">Create</span>.<br>
                      Do the <span class="fw-bold">2FA</span> as needed.
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_subaccount_form.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bitget_subaccount_form.jpg" zoom="/exchanges/explainers/bitget_subaccount_form.jpg" />

                    <p>
                      <span class="fw-bold">RELOAD</span> to see the new Sub-account appear in the Sub-account management list.<br>
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_find_your_subaccount.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bitget_find_your_subaccount.jpg" zoom="/exchanges/explainers/bitget_find_your_subaccount.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Now let's create the API Keys.<br>
                      For that click on the <a href="https://www.bitget.com/account/newapi" target="_blank" ><span class="fw-bold">API keys</span></a> menu items on the left hand side.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_apikeys_menu_item.jpg" />

                    <p>Select the <span class="fw-bold">Sub-account</span> you want to create the API Key for.</p>
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/bitget_select_subaccount.jpg" zoom="/exchanges/explainers/bitget_select_subaccount.jpg" />

                    <p>
                      Click on <span class="fw-bold">Create API key</span>.<br>
                      ATTENTION: Make sure you have selected the Sub-account first, otherwise your API key will be for the Main Account, which is not what you want!
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_create_api_button.jpg" />

                    <p>Choose the <span class="fw-bold">API Type</span> as shown.</p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_select_api_type.jpg" />

                    <p>
                      Choose <span class="fw-bold">settings</span> as shown.<br>
                      Choose a <span class="fw-bold">Passphrase</span> and <span class="fw-bold">remember</span> it. You will need it for the SIGNUM setup.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_api_settings_1.jpg" />

                    <p>
                      Choose the <span class="fw-bold">permissions</span> as shown.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_api_settings_2.jpg" />

                    <p>
                      Add SIGNUM's IP address, for additional security: <span class="fw-bold">18.199.127.118</span><br>
                      Click <span class="fw-bold">Next</span> and do <span class="fw-bold">2FA</span> as needed.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_api_settings_3.jpg" />

                    <p>
                      Now paste your new <span class="fw-bold">API Key, API Secret & Passphrase</span> (the one you defined above) into SIGNUM.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/bitget_copy_credentials_to_signum.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Crypto.com Explainers -->
    <div v-if="selectedExchange?.id == 'cryptodotcom'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your 20% Trading Fee Discount on {{ selectedExchange.name }} (Spot & Futures)</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below to get your <span class="fw-bold">FEE DISCOUNT</span>:
                  <br>
                  <a href="https://crypto.com/exch/michaelautomates" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the accounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below :)
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://crypto.com/exchange/" target="_blank"><span class="fw-bold">{{ selectedExchange.name }} account</span></a> and go to your <a href="https://crypto.com/exchange/user/account-management" target="_blank"><span class="fw-bold">Account Management</span></a>.<br>
                      Click on <span class="fw-bold">Create Sub-account</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_create_subaccount_button.jpg" />

                    <p>
                      Choose an <span class="fw-bold">Account Label</span> (aka. title) and click <span class="fw-bold">Review</span>.<br>
                      Then click <span class="fw-bold">Confirm</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_create_subaccount_label.jpg" />

                    <p>
                      Your new <span class="fw-bold">Sub-account</span> now appears in the accounts list. Nice :)<br>
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_create_subaccount_done.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Now let's create the API Keys.<br>
                      For that you need to <span class="fw-bold">switch into the Sub-account</span> first!.<br>
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-1" src="/exchanges/explainers/cryptocom_switch_subaccount_1.jpg" />
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_switch_subaccount_2.jpg" />

                    <p>
                      <span class="fw-bold">Make sure you are inside your Sub-account!</span><br>
                      Click on your <span class="fw-bold">profile icon</span> and then on <span class="fw-bold">Manage Account</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_click_profile.jpg" />

                    <p>
                      Click on <span class="fw-bold">Create new API key</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_click_create_api_key_button.jpg" />

                    <p>
                      Set the API key label to <span class="fw-bold">SIGNUM</span>.<br>
                      Click <span class="fw-bold">Create API</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_create_api_key_label.jpg" />

                    <p>
                      <span class="fw-bold">COPY YOUR KEYS NOW!</span><br>
                      After editing, the <span class="fw-bold">Secret Key</span> will be hidden!<br>
                      <br>
                      Choose the <span class="fw-bold">permissions</span> as shown.<br>
                      Add SIGNUMS <span class="fw-bold">API Address</span> for added security: <span class="fw-bold">18.199.127.118</span>.<br>
                      Click <span class="fw-bold">Save</span>.<br>
                      It's best to <span class="fw-bold">Reload</span> the page and check if the settings have been saved!
                    </p>
                    <!-- <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_create_api_key_settings.jpg" /> -->
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/cryptocom_create_api_key_settings.jpg" zoom="/exchanges/explainers/cryptocom_create_api_key_settings.jpg" />

                    <p>
                      Now scroll up and paste your the <span class="fw-bold">API Key, Secret Key</span> into the form above.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/cryptocom_paste_into_signum.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Hyperliquid Explainers -->
    <div v-if="selectedExchange?.id == 'hyperliquid'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your 4% Trading Fee Discount on {{ selectedExchange.name }} (Spot & Futures)</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below to get your <span class="fw-bold">FEE DISCOUNT</span>:
                  <br>
                  <a href="https://app.hyperliquid.xyz/join/SIGNUM" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                  <br>
                  <br>
                  If you already have an account, go to <a href="https://app.hyperliquid.xyz/referrals" target="_blank" class="fw-bold">Referrals</a>, click on <span class="badge badge-subtle-success">Enter Code</span> and type in <span class="badge badge-subtle-success">SIGNUM</span> to get the discount.
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Account</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">2. Fund Account</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">3. Create API</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the accounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below :)
                    </p>

                    <hr>

                    <div class="alert alert-warning" role="alert">
                      <span class="fw-bold">{{ selectedExchange.name }} Subaccounts</span><br>
                      {{ selectedExchange.name }} allows Subaccounts only for accounts with <span class="fw-bold">over $100k total trading volume</span>, so we will create separate Main Accounts in order to use {{ selectedExchange.name }} for trade automation. This way we enable everyone ❤️<br>
                      <br>
                      If you have access to Subaccounts, you can also connect them. Simply create a Subaccount (instead of a Main Account) and connect it to SIGNUM.
                    </div>

                    <p>
                      You can create an acccount either via <b>email</b> or via creating multiple <b>accounts in your web3 wallet</b> (e.g. Metamask).<br>
                      <br>
                      We will explain the <b>email version</b> as it's the easiest one and you can also login to it from any device as long as you have access to your emails (e.g. Mobile, Tablet).<br>
                      <br>
                      For that we will use email aliases using + sign. It's a great feature Gmail supports (possibly also others). Watch this <a href="https://www.youtube.com/shorts/jTxRCEpUgt0" target="_blank"><b>YouTube video</b> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand how they work in general.
                    </p>

                    <hr>

                    <p>
                      Go to <a href="https://app.hyperliquid.xyz/trade" target="_blank"><span class="fw-bold">{{ selectedExchange.name }}</span></a> and click on the <b>Connect</b> button on the top.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/hype_connect_button.jpg" />

                    <hr>

                    <p>
                      Select <b>Log in via Email</b>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/hype_create_email_account.jpg" />

                    <hr>

                    <p>
                      Type a unique email to connect.<br>
                      Signup and Login are the same operation, that's why {{ selectedExchange.name }} calls it <b>Connect</b>.<br>
                      Remember that each account acts as a <b>Subaccount</b>, so choose your email alias name as you would for a subaccount.<br>
                      <br>
                      Example:<br>
                      If your email is <b>Satoshi.Nakamoto@gmail.com</b> then you can add an alias before the <b>@</b>, like so: <b>Satoshi.Nakamoto<span style="color: red">+HypeGaussianBTC</span>@gmail.com</b><br>
                      <br>
                      Click <b>Submit</b> and login with the <b>confirmation code</b> you have received via email.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/hype_type_email_and_submit.jpg" />

                    <hr>

                    <p>
                      When naming your Bot, we recommend adding the <b>email alias</b> to the <b>Bot title</b> so you remember, which login you used for each Bot.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/hype_bot_title.jpg" />

                    <hr>

                    <p>Go to the next tab called <span class="fw-bold">Fund Account</span>...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p>Go to the next tab called <span class="fw-bold">Create API</span>...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">

                    <div class="alert alert-warning" role="alert">
                      <span class="fw-bold">{{ selectedExchange.name }} Requires Funds</span><br>
                      Before being allowed to create your API Key, {{ selectedExchange.name }} requires you to fund your account. Go to the previous step, fund your account and come back here afterwards.
                    </div>

                    <p>
                      Now let's create the API Keys.<br>
                      For that click on the <b>API</b> menu item to get to the <a href="https://app.hyperliquid.xyz/API" target="_blank"><b>API settings</b></a>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-1" src="/exchanges/explainers/hype_api_menu_item.jpg" />

                    <hr>

                    <p>
                      For the <b>API Name</b> type <b>SIGNUM</b>.<br>
                      Then click <b>Generate</b> to generate the <b>API Address</b> (aka. API Key).<br>
                      Now click on the <b>Authorize API Wallet</b> button.
                    </p>
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/hype_generate_api_key.jpg" zoom="/exchanges/explainers/hype_generate_api_key.jpg" />

                    <hr>

                    <p>
                      Click on <b>MAX</b> to give the API Keys the longest validaity {{ selectedExchange.name }} allows.<br>
                      SIGNUM will allow you to edit those keys so you can keep your Bots running for ever.<br>
                      <b>ATTENTION:</b> {{ selectedExchange.name }} doesn't offer a way for us to check how long your API Keys are still valid, so we cannot warn you before they expire.<br>
                      <br>
                      Copy the <b>API Wallet Address</b> and the <b>Private Key</b> into the SIGNUM form above. Do <b>NOT</b> click Validate yet.<br>
                      <br>
                      Click on <b>Authorize</b> to create the API Key.<br>
                    </p>
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/hype_api_key_dialog.jpg" zoom="/exchanges/explainers/hype_api_key_dialog.jpg" />

                    <hr>

                    <p>
                      The 3rd needed item is the <b>Public Address</b> and you'll find it the top drop-down menu.<br>
                      <b>Copy</b> it into the SIGNUM form above.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/hype_public_address.jpg" />

                    <hr>

                    <p>
                      With all 3 form fields filled in properly, click <b>Validate</b>.<br>
                      <br>
                      <b>ATTENTION:</b> {{ selectedExchange.name }} doesn't offer a way for us to truly validate if your API Keys are correct! You have to trigger a trade to truly be sure.<br>
                    </p>
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/hype_validate_api_keys.jpg" zoom="/exchanges/explainers/hype_validate_api_keys.jpg" />

                    <hr>

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Gate Explainers -->
    <div v-if="selectedExchange?.id == 'gate'" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your 20% Trading Fee Discount on {{ selectedExchange.name }} (Spot, Futures, Alpha, Web3)</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below to get your <span class="fw-bold">FEE DISCOUNT</span>:
                  <br>
                  <a href="https://www.gate.com/share/SIGNUMGO" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the accounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below :)
                    </p>

                    <hr>

                    <p>
                      Login to your <a href="https://www.gate.com/" target="_blank"><span class="fw-bold">{{ selectedExchange.name }} account</span></a> and go to your <a href="https://www.gate.com/myaccount/sub_account_manage" target="_blank"><span class="fw-bold">Subaccounts</span></a>.<br>
                      Click on <span class="fw-bold">Create Subaccount</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/gate_create_subaccount_button.jpg" />

                    <p>
                      Choose a unique <span class="fw-bold">Username</span> for your Subaccount.<br>
                      They want it to be unique accross the entire platform, so add a prefix, like your initials.<br>
                      Choose the <span class="fw-bold">Account Type</span> as shown.<br>
                      Click <span class="fw-bold">Confirm & Create</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/gate_subaccount_form.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Now let's create the API Keys.<br>
                      Go to your <a href="https://www.gate.com/myaccount/sub_account_manage" target="_blank"><span class="fw-bold">Subaccounts</span></a>.<br>
                      Click on <span class="fw-bold">Manage</span> and then on <span class="fw-bold">API</span> for the Subaccount in question.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/gate_manage_api_button.jpg" />

                    <p>
                      Click <span class="fw-bold">Create API Key</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/gate_create_api_key_button.jpg" />

                    <p>
                      Fill in the form as shown below.<br>
                      Add the SIGNUM IP Address to make your API Key permanent: <span class="fw-bold">18.199.127.118</span><br>
                      Click <span class="fw-bold">Submit</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/gate_api_settings.jpg" />

                    <p>
                      Congrats, you now have your API Keys 🥳
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/gate_api_keys.jpg" />

                    <p>
                      Now copy the <span class="fw-bold">API Key & Secret</span>, scroll up and paste them into the form.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/gate_copy_keys_to_signum.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- OKX Explainers -->
    <div v-if="['okx', 'okxus', 'okxeea'].includes(selectedExchange?.id)" class="row justify-content-center mt-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Help for {{ selectedExchange.name }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary text-center">
            <div class="col-12 text-start">

              <div>
                <div class="alert alert-primary mt-0 mb-3" role="alert" style="background-image:url(backgrounds/corner-2.png)">
                  <span class="fw-bold">Get Your 15% Trading Fee Discount on {{ selectedExchange.name }} (Spot, Futures)</span>
                  <br>
                  Sign up to {{ selectedExchange.name }} with the button below to get your <span class="fw-bold">FEE DISCOUNT</span>:
                  <br>
                  <a href="https://www.okx.com/join/SIGNUM" target="_blank" class="btn btn-primary btn-sm mt-1" type="button">
                    <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                    Create {{ selectedExchange.name }} Account
                  </a>
                </div>
                <p>Go through <span class="fw-bold">all tabs</span> to finish your setup.</p>

                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tab-create-subaccount" role="tab" aria-controls="tab-create-subaccount" aria-selected="true">1. Create Subaccount</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-create-api" role="tab" aria-controls="tab-create-api" aria-selected="false">2. Create API</a></li>
                  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tab-fund-account" role="tab" aria-controls="tab-fund-account" aria-selected="false">3. Fund Account</a></li>
                </ul>
                <div class="tab-content border-top-0 pt-3">
                  <div class="tab-pane fade text-center show active" id="tab-create-subaccount" role="tabpanel">
                    <p>
                      <span class="fw-bold">We require each Bot to run on its own Subaccount!</span><br>
                      This is best practice and avoids multiple issues later on. <a href="https://www.youtube.com/watch?v=0YMe4ZcTcuk" target="_blank"><span class="fw-bold">Watch this YouTube video</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a> to understand why and thank us later 😊
                    </p>
                    <p>
                      If you are <span class="fw-bold">migrating from another tool</span> to SIGNUM, you can use the Subaccounts you already have, just <span class="fw-bold">create a new API Key</span> for SIGNUM based on the instructions below.
                    </p>

                    <hr>
                    <div v-if="form.tradingAccount == 'spot'">
                      <p>
                        Login to your <a href="https://my.okx.com/en-eu/account/sub-account" target="_blank"><span class="fw-bold">{{ selectedExchange.name }} account</span></a> and go to your <a href="https://my.okx.com/en-eu/account/sub-account" target="_blank"><span class="fw-bold">Sub-accounts</span></a>.<br>
                        Click on <span class="fw-bold">Create sub-accounts</span>.
                      </p>
                      <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_create_subaccount_button.jpg" zoom="/exchanges/explainers/okx_create_subaccount_button.jpg" />

                      <p>
                        Give it a unique name and choose the settings as shown.<br>
                        Click <span class="fw-bold">Submit all</span>.<br>
                        Do 2FA as needed.
                      </p>
                      <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_create_subaccount_form.jpg" zoom="/exchanges/explainers/okx_create_subaccount_form.jpg" />
                    </div>
                    <div v-if="form.tradingAccount == 'perpetual'">
                      <p>
                        Login to your <a href="https://my.okx.com/en-eu/account/sub-account" target="_blank"><span class="fw-bold">{{ selectedExchange.name }} account</span></a>.<br>
                        First you need to unlock <span class="fw-bold">X-Perps</span> (one-time process).<br>
                        Click on <span class="fw-bold">Trade</span> and then on <span class="fw-bold">Unlock X-Perps</span>.<br>
                        Follow the steps and answer the questionaire as {{ selectedExchange.name }} requires.
                      </p>
                      <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okxeea_perps_enable_xperps.jpg" zoom="/exchanges/explainers/okxeea_perps_enable_xperps.jpg" />

                      <p>
                        Now go to your <a href="https://my.okx.com/en-eu/account/sub-account" target="_blank"><span class="fw-bold">Sub-accounts</span></a>.<br>
                        Click on <span class="fw-bold">Create sub-accounts</span>.<br>
                      </p>
                      <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_create_subaccount_button.jpg" zoom="/exchanges/explainers/okx_create_subaccount_button.jpg" />

                      <p>
                        Give it a unique name and choose the settings as shown.
                      </p>
                      <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_perps_create_subaccount_form.jpg" zoom="/exchanges/explainers/okx_perps_create_subaccount_form.jpg" />

                      <p>
                        Click on <span class="fw-bold">Edit</span> and select <span class="fw-bold">Futures mode</span> (if it doesn't load, try a few times).<br>
                        Click <span class="fw-bold">Save</span>.<br>
                        Click <span class="fw-bold">Submit all</span>.<br>
                        Do 2FA as needed.
                      </p>
                      <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_perps_futures_mode.jpg" zoom="/exchanges/explainers/okx_perps_futures_mode.jpg" />
                    </div>

                    <p>Go to the next tab <span class="fw-bold">Create API</span> to create your API credentials...</p>

                  </div>
                  <div class="tab-pane fade text-center" id="tab-create-api" role="tabpanel">
                    <p>
                      Go to your <a href="https://my.okx.com/en-eu/account/sub-account" target="_blank"><span class="fw-bold">Sub-accounts</span></a>.<br>
                      For the Subaccount in question, click on the <span class="fw-bold">three dots</span> and click on <span class="fw-bold">Manage API</span>.
                    </p>
                    <vue-image-zoomer v-if="form.tradingAccount == 'perpetual'" img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_perps_manage_api_button.jpg" zoom="/exchanges/explainers/okx_perps_manage_api_button.jpg" />
                    <vue-image-zoomer v-else img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_manage_api_button.jpg" zoom="/exchanges/explainers/okx_manage_api_button.jpg" />

                    <p>
                      Make sure the right <span class="fw-bold">Sub-account</span> is selected.<br>
                      Now create a new API Key for the Sub-account by clicking on the <span class="fw-bold">Create API key</span> button.<br>
                    </p>
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="2" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_create_api_key_button.jpg" zoom="/exchanges/explainers/okx_create_api_key_button.jpg" />

                    <p>
                      Choose the <span class="fw-bold">settings</span> as shown below.<br>
                      Make sure the selected <span class="fw-bold">Account</span> is the <span class="fw-bold">Sub-account</span> you want to connect your Bot to.<br>
                      Put SIGNUM's <span class="fw-bold">IP Address</span>, for additional security: <span class="fw-bold">18.199.127.118</span><br>
                      Choose a <span class="fw-bold">Passphrase</span> and remember it!<br>
                      Click <span class="fw-bold">Submit all</span>
                    </p>
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_create_api_key_form.jpg" zoom="/exchanges/explainers/okx_create_api_key_form.jpg" />

                    <p>
                      Click on <span class="fw-bold">Show info</span> to see the <span class="fw-bold">API key</span> and <span class="fw-bold">Secret key</span>.
                    </p>
                    <vue-image-zoomer img-class="img-fluid rounded mx-auto d-block mb-3" :click-zoom="true" :zoom-amount="1.5" :show-message-touch="false" :tap-to-close="true" regular="/exchanges/explainers/okx_copy_keys.jpg" zoom="/exchanges/explainers/okx_copy_keys.jpg" />

                    <p>
                      Now paste the <span class="fw-bold">API Key, Secret and Passphrase</span> into SIGNUM.<br>
                      Click <span class="fw-bold">Validate</span>.
                    </p>
                    <img class="img-fluid rounded mx-auto d-block mb-3" src="/exchanges/explainers/okx_paste_into_signum.jpg" />

                    <p>Go to the next tab <span class="fw-bold">Fund Account</span> to fund your Subaccount...</p>
                  </div>
                  <div class="tab-pane fade text-center" id="tab-fund-account" role="tabpanel">
                    <ExchangeAddFundsInfo :bot="tempBot" />

                    <p><span class="fw-bold">Done 👏🏻</span></p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div> <!-- row -->

    <!-- Latency Alert -->
    <div class="row justify-content-center mt-4 mb-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <TheLatencyAlert />
      </div>
    </div> <!-- row -->

  </form>

</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import BotEditForm from '@/components/BotEditForm'
import TheLatencyAlert from '@/components/TheLatencyAlert'
import Tab from 'bootstrap/js/dist/tab.js'
import { VueImageZoomer } from 'vue-image-zoomer' // https://www.npmjs.com/package/vue-image-zoomer
import 'vue-image-zoomer/dist/style.css';
import { userHelperMixin } from '@/mixins/userHelperMixin'
import ExchangeAddFundsInfo from '@/components/ExchangeAddFundsInfo'
import { apiFetch } from '@/api/apiFetch'

export default {
  mixins: [userHelperMixin],
  components: {
    TheNavbar,
    TheLatencyAlert,
    BotEditForm,
    VueImageZoomer,
    ExchangeAddFundsInfo
  },
  props: {
  },
  data () {
    return {
      step: 1,
      loading: false,
      selectedExchange: null, // Object
      form: {
        title: '',
        enabled: true,
        exchangeId: '',
        tradingAccount: 'spot',
        exchangeConfig: {
          passphrase: '', // KuCoin, Bitget, Hyperliquid (publicAddress)
          apiKey: '',
          apiSecret: '',
          isTestNet: false
        },
        baseCoin: '',
        quoteCoin: '',
        ipAllowedTradingView: true,
        ipAllowedMake: false,
        ipAllowedCustomList: ''
      },
      formValidations: {
        apiKey: ''
      }
    }
  },
  computed: {
    tempBot () {
      // Create a temporary bot object so other components can work with it until the real bot object exists
      return {
        exchangeId: this.selectedExchange.id,
        tradingAccount: this.form.tradingAccount
      }
    },
    userBots () {
      return this.$store.getters.getUserBots
    },
    platformExchanges () {
      return this.$store.getters.getPlatformExchanges
    },
    platformExchangesFiltered () {
      const platformExchanges = this.$store.getters.getPlatformExchanges
      let platformExchangesFiltered = []

      for (let exchange of platformExchanges) {
        if (exchange.features.tradingAccount[this.form.tradingAccount]) {
          platformExchangesFiltered.push(exchange)
        }
      }

      return platformExchangesFiltered
    },
    apiKeyLabelName () {
      let name = 'API Key'
      if (this.selectedExchange.id == 'coinbase') name = 'API Key Name'
      if (this.selectedExchange.id == 'mexc') name = 'Access Key'
      if (this.selectedExchange.id == 'hyperliquid') name = 'API Wallet Address'
      return name
    },
    apiSecretLabelName () {
      let name = 'API Secret'
      if (this.selectedExchange.id == 'coinbase') name = 'Private Key'
      if (this.selectedExchange.id == 'mexc') name = 'Secret Key'
      if (this.selectedExchange.id == 'hyperliquid') name = 'Private Key'
      return name
    }
  },
  methods: {
    // this function controls which users can see exchanges when they are new and not yet stable.
    // this way we can control who gets to use freshly supported exchange first before the general public.
    exchangeEnabled (exchange) {
      // admin users can always see all exchanges
      const userProfile = this.$store.getters.getUserProfile
      if (userProfile?.roles[0] == 'ROLE_ADMIN') return true

      // power users can always see all exchanges
      if (this.userMaxBotsMix >= 50) {
        return true
      }

      // add rules here that return FALSE, to disable an exchange under specific circumstances
      // example:
      if (exchange.id == 'pulam-eea' && this.form.tradingAccount == 'perpetual') return false; // example rule

      return true
    },
    selectExchangeTradingAccount (tradingAccount) {
      this.form.tradingAccount = tradingAccount
      this.form.exchangeId = ''
      this.selectedExchange = null

      // Clear all error messages when switching between exchanges
      this.formValidations = {}
    },
    selectExchange (exchange) {
      this.selectedExchange = exchange
      this.form.exchangeId = exchange.id
      this.form.exchangeConfig.passphrase = ''
      this.form.exchangeConfig.apiKey = ''
      this.form.exchangeConfig.apiSecret = ''

      // Clear all error messages when switching between exchanges
      this.formValidations = {}
    },
    getSupportUrl () {
      return process.env.VUE_APP_SUPPORT_URL
    },
    getSelectedExchangeClasses (exchangeId) {
      let classes = ' '

      if (this.selectedExchange?.id == exchangeId) {
        classes += ' img-thumbnail '
      } else {
        classes += ' opacity-25 '
      }

      return classes
    },
    getSelectedExchangeTradingAccountClasses (tradingAccount) {
      let classes = ' '

      if (this.form.tradingAccount == tradingAccount) {
        classes += ' img-thumbnail '
      } else {
        classes += ' opacity-25 '
      }

      return classes
    },
    async onSave (event) {
      this.loading = true

      let newBot = event.newBot

      this.form.title = newBot.title
      this.form.exchange = this.form.exchangeId
      this.form.baseCoin = newBot.baseCoin
      this.form.quoteCoin = newBot.quoteCoin

      // Create the POST object
      let postData = this.form
      // Fix the JSON.stringify issue for Coinbase
      postData.exchangeConfig.apiSecret = this.form.exchangeConfig.apiSecret.replace(/\\n/g, "\n")
      postData.exchangeConfig.publicAddress = postData.exchangeConfig.passphrase // In UI it's handeled via the passphrase variable but in API it's also passed as the publicAddress so Hyperliquid works

      // console.log("newBot", this.form)
      const newBotFromApi = await this.$store.dispatch('createBot', postData)
      this.$router.push({ name: 'EditBot', params: {id: newBotFromApi.id}, query: {cameFrom: 'createBot'} })

      this.loading = false
    },
    async validateExchange () {
      this.loading = true
      this.formValidations = {}

      if (!this.form.exchangeId) {
        this.formValidations.apiKey = "Please pick an exchange"
        this.loading = false
        return false
      }

      if (!this.form.exchangeConfig.apiKey) {
        this.formValidations.apiKey = "Enter your "+this.apiKeyLabelName
        this.loading = false
        return false
      }

      if (!this.form.exchangeConfig.apiSecret) {
        this.formValidations.apiKey = "Enter your "+this.apiSecretLabelName
        this.loading = false
        return false
      }

      // Validate passphrase for the exchanges who need it
      if (['kucoin', 'bitget', 'hyperliquid', 'okx', 'okxus', 'okxeea'].includes(this.form.exchangeId)) {
        if (!this.form.exchangeConfig.passphrase) {

          // Show different error message for Hyperliquid due to their different naming conventions
          if (this.form.exchangeId == 'hyperliquid') {
            this.formValidations.apiKey = "Enter your Master, Vault or Sub-Account Address"
          } else {
            this.formValidations.apiKey = "Enter your API Passphrase"
          }

          this.loading = false
          return false
        }
      }

      if (this.form.exchangeId == 'hyperliquid') {
        // Remove "HL:" from all Hyperliquid keys to be sure
        this.form.exchangeConfig.apiKey = this.form.exchangeConfig.apiKey.replace('HL:', '')
        this.form.exchangeConfig.apiSecret = this.form.exchangeConfig.apiSecret.replace('HL:', '')
        this.form.exchangeConfig.passphrase = this.form.exchangeConfig.passphrase.replace('HL:', '')
      }

      if (this.form.exchangeId && this.form.exchangeConfig.apiKey && this.form.exchangeConfig.apiSecret) {

        // Validate if API Key is already in use and where
        // Fetch userBots if not available
        if (!this.$store.getters.getUserBots) this.$store.dispatch('getUserBots')

        // Find the bot with the API Keys
        let botWithSameAccount = null
        if (this.form.exchangeId == 'hyperliquid') {
          // On Hyperliquid, the publicAddress identifies the account itself, which is nice. We only need make sure users use the same account once in this case. They can re-use the API Wallet Address (and Private Key) as long as they put a unique public address.
          botWithSameAccount = this.$store.getters.getUserBots.find(elem => elem.exchangeConfig.publicAddress === this.form.exchangeConfig.passphrase) // Avoid users connecting the same Hyperliquid account more than once. We store the publicAddress in the passphrase variable until we send it to the API.
        } else {
          botWithSameAccount = this.$store.getters.getUserBots.find(elem => elem.exchangeConfig.apiKey === this.form.exchangeConfig.apiKey)
        }

        if (botWithSameAccount) {
          this.formValidations.apiKey = `These credentials are already in use by another bot with the title "${botWithSameAccount.title}". It's best practice to separte each trading bot into it's own account to separate the budgets and keep them from overlapping. Create a new (sub)-account and use its credentials."`
          this.loading = false
          return false
        }

        // Create the POST object
        let postData = {
          passphrase: this.form.exchangeConfig.passphrase, // Used for Kucoin, Bitget, OKX
          publicAddress: this.form.exchangeConfig.passphrase, // Used for Hyperlqiuid
          apiKey: this.form.exchangeConfig.apiKey,
          secretKey: this.form.exchangeConfig.apiSecret.replace(/\\n/g, "\n"),
          tradingAccount: this.form.tradingAccount,
          isTestNet: false
        }

        // Make the api call
        const url = process.env.VUE_APP_API_URL+'/exchange/credentials/'+this.form.exchangeId
        const rawResponse = await apiFetch(url, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(postData), // body data type must match "Content-Type" header
        })

        if (rawResponse.status === 200) {
          this.step = 2
          this.loading = false
          return true
        } else {
          try {
            const response = await rawResponse.json()
            this.formValidations.apiKey = response.error+': '+response.description
            this.loading = false
            return false
          } catch (e) {
            console.log(e)
          }

          this.formValidations.apiKey = "These credentials are not valid"
        }
      }

      this.loading = false
      return false
    },
    cancel () {
      this.$router.back()
    }
  },
  async created () {
    if (!this.$store.getters.getPlatformExchanges) await this.$store.dispatch('getPlatformExchanges')
    if (!this.$store.getters.getUserBots) await this.$store.dispatch('getUserBots')

    // Inform user about max bots reached
    if (this.userBots?.length >= this.userMaxBotsMix) {
      this.step = 3
    }

    // Select the first Exchange so the UI is properly initialized
    // this.selectExchange(this.platformExchanges[0])
    // this.selectedExchange = this.platformExchanges[0]
  },
  async beforeMount () {
    // Redirect to Login when the user is not logged in
    if (!this.$store.getters.isUserLoggedIn) this.$router.push({ name: 'Login' })
  },
  mounted () {
    console.debug(Tab) // Must use Tab but don't actually need to
  },
  unmounted () {
    // TODO: Is this really needed?
    // Reset data to be sure it's clean when editing the next bot
    // this.form = {}
    // this.formValidations = {}
  }
}
</script>

<style scoped>
  img.tradingAccount {
    cursor: pointer;
  }
  img.exchange {
    cursor: pointer;
  }
</style>
